import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import LinkWithIcon from "@/components/LinkWithIcon/LinkWithIcon"
import { MODALS } from "@/constants/modals"
import { useSkillsData } from "@/queries/queries"
import type { SkillDTO } from "@/types/skillsTypes"
import { editIcon } from "@/utils/variables"
import { useStore } from "@/zustand/store"
export default function Skills() {
  const { t } = useTranslation()
  const { data } = useSkillsData()
  const { editModalState } = useStore()

  const allSkills = useMemo<Array<SkillDTO>>(() => {
    if (!data) return [] as Array<SkillDTO>

    const courseSkills = (data?.skills_course ?? []).map((skill) => ({
      title: skill || "",
      is_course_skill: true,
    }))

    const studentSkills = (data?.skills_student ?? []).map((skill) => ({
      title: skill || "",
      is_course_skill: false,
    }))

    return [...courseSkills, ...studentSkills]
  }, [data?.skills_course, data?.skills_student])

  return (
    <div className="skills bg-white">
      <div className="d-flex gap-4 align-items-center justify-content-between mb-4">
        <h3 className="m-0">{t("profilePage.skills.title")}</h3>
        <LinkWithIcon
          icon={editIcon}
          onClick={() => {
            editModalState(MODALS.skills.edit, allSkills)
          }}
          title={t("buttons.edit")}
          color={"#243B78"}
        />
      </div>
      {!data?.skills_course?.length && !data?.skills_student?.length && (
        <p className="m-0 text-center fs-4">{t("profilePage.skills.noData")}</p>
      )}

      <div className="links d-flex align-items-center gap-3 flex-wrap">
        {allSkills.map((el, index) => {
          return (
            <p key={index} className="skill m-0">
              {el?.title}
            </p>
          )
        })}
      </div>
    </div>
  )
}
